// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + chunkId + "--" + {"2297":"0f60dbd","3318":"cd4dddf","8816":"c6a7df5"}[chunkId] + ".js";
};